import { get } from "lodash";

export const selectModal = (state, modal) =>
  get(state, `modals.${modal}`, false);
